module.exports = __webpack_public_path__ + "assets/14bec3000ed508868cb5670600ac822f.mp3";